// extracted by mini-css-extract-plugin
export default {"tabbed":"tabbed__LgjK0","tabs":"tabs__qSLmM","tab":"tab__fdfmi","tab-content":"tab-content__KMyb6"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"tabbed\":\"tabbed__LgjK0\",\"tabs\":\"tabs__qSLmM\",\"tab\":\"tab__fdfmi\",\"tab-content\":\"tab-content__KMyb6\"}";
        // 1787130558066
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  